import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from '@emotion/react';

export default function CustomTableAllTransport(props) {
  const getDate = (value) => {
    const cleanValue = value?.replace(/(\d+)(st|nd|rd|th)/, '$1');

    const event = new Date(cleanValue);
    if (isNaN(event.getTime())) return value; // fallback if date is invalid
    const locale = 'fa-IR'
    if (locale === 'fa-IR') {
      const arr = ['دی', 'بهمن', 'اسفند', 'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر'];
      const convertmonths = ['جدی', 'دلو', 'حوت', 'حمل', 'ثور', 'جوزا', 'سرطان', 'اسد', 'سنبله', 'میزان', 'عقرب', 'قوس'];

      const getMonth = event.toLocaleDateString(locale, { month: 'long' });
      const currentDate = event.toLocaleDateString(locale, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
      const getIndMonth = arr.indexOf(getMonth);
      return currentDate.replace(getMonth, convertmonths[getIndMonth]);
    }

    return event.toLocaleDateString(locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const theme = useTheme();
  const style = theme.palette;

  // Calculate the sum of Fees
  const sumFees = props.data?.reduce((total, row) => {
    const fees = parseFloat(row.Fees) || 0;
    return total + fees;
  }, 0);

  // Calculate the sum of Balance
  const Balance = props.data?.reduce((total, row) => {
    const fees = parseFloat(row.Balance) || 0;
    return total + fees;
  }, 0);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 515 }} aria-label="caption table">
        <TableHead>
          <TableRow sx={{background: style.primary.main}} id="thead">
            {props.data &&
              Object.keys(props.data[0]).map((key) => (
                <TableCell key={key} sx={{color:style.sidemenutext.color}}>
                  {key == 'Month'? 'Month' : 
                   key == 'roll'? 'Roll Num.' : 
                   key == 'RollNum'? 'Roll Num.' : 
                   key == 'Srn'? 'Srn.' : 
                   key == 'Date' ? 'Date' : 
                   key == 'Fees'? 'Fees': 
                   key == 'Discount'? 'Discount':
                   key == 'StudentSrn'? 'Roll Number':
                   key == 'StartDate'? 'Start Date':
                   key == 'name'? 'Name':
                   key == 'Class'? 'Class':
                   key == 'Comments'? 'Comments' :
                   key == 'paidFees'? 'Paid Fees':
                   key == 'Description'? 'Description':
                   key == 'Dues'? 'Dues':
                   key == 'Paid Amount'? 'Paid Amount':
                   key == 'NamePashto'? 'Name': 
                   key == 'FNamePashto'? 'Father Name': 
                   key == 'TellNo1'? 'Mobile': 
                   key == 'TotalPaidFees'? 'Paid Fees': //TotalPaidFees
                   key == 'TotalFees'? 'Total Fees': //TotalPaidFees
                   key == 'Balance'? 'Balance': //TotalPaidFees
                   key == 'Ammount'? 'Amount' : null}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data &&
            props.data.map((row, ind) => (
              row.Description == 'Total' ?
              <TableRow key={ind}>
                {Object.values(row).map((value, index) => (
                  <TableCell key={index}><b>{value}</b></TableCell>
                ))}
              </TableRow>
              :
              <TableRow key={ind}>
                {Object.entries(row).map(([key, value], index) => (
                  <TableCell key={index}>
                    {key === 'Date' ? 
                      <><span style={{ fontSize: '14px' }}>{getDate(value)}</span><br/>{value}</>
                    : value}
                  </TableCell>
                ))}
              </TableRow>
            ))}
            
          {/* Add footer row with sum of Fees */}
          {props.data && props.data.some(row => 'Fees' in row) && (
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell colSpan={Object.keys(props.data[0]).length - 3} align="right">
                <b>Total Transport Fees:</b>
              </TableCell>
              <TableCell>
                <b>{sumFees?.toFixed(2)}</b>
              </TableCell>
              <TableCell>
              </TableCell>
              <TableCell>
              </TableCell>

            </TableRow>
          )}

          {/* Add footer row with sum of Fees */}
          {props.data && props.data.some(row => 'Balance' in row) && (
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              
              <TableCell>
              </TableCell>
              <TableCell>
              </TableCell>
              <TableCell colSpan={Object.keys(props.data[0]).length - 3} align="right">
                <b>Total Balance:</b>
              </TableCell>
              <TableCell>
                <b>{Balance?.toFixed(2)}</b>
              </TableCell>

            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}